import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { IcoMoonSpinner4 } from '../ico-moon';

/**
 * Styled container
 */
const Container = styled.div`
  min-height: 10em;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 0.7em;
  > * {
    text-align: center;
  }
`;

/**
 * Styled message
 */
const Message = styled.div`
  color: grey;
  max-width: 20em;
  display: flex;
  flex-direction: column;
`;

/**
 * Loading component
 * Renders a loading icon over the whole page
 */
const Indicator = ({ icon: Icon, spin, text, children, ...rest }) => (
  <Container {...rest}>
    <Icon className={spin ? 'spin' : ''} size="5em" />
    <Message> {text || children} </Message>
  </Container>
);

Indicator.propTypes = {
  icon: PropTypes.any,
  text: PropTypes.string,
  spin: PropTypes.bool
};

Indicator.defaultProps = {
  icon: IcoMoonSpinner4,
  text: '',
  spin: false
};

export default Indicator;
